export default __webpack_public_path__ + "4e7cbb638af327f0933fa9cfaf8c633f.svg";